import React, { useContext, useState } from "react";
import AdvisorNavbar from "../layout/AdvisorNavbar";
import LocContext from "../context/locContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FiFileText, FiPlus, FiShare2, FiX, FiClock, FiCheckCircle } from "react-icons/fi";
import Swal from "sweetalert2";
import { NavLink } from "react-router-dom";

export default function DraftOrders() {
  const { userData } = useContext(LocContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientId") || "1";
  const [showCreateForm, setShowCreateForm] = useState(false);

  const [draftForm, setDraftForm] = useState({
    orderType: "Lumpsum",
    schemeName: "",
    amount: "",
    sipFrequency: "Monthly",
    sipStartDate: "",
    sipDuration: "",
  });

  const [drafts] = useState([
    {
      id: 1,
      clientName: "Rajesh Kumar",
      orderType: "Lumpsum",
      schemeName: "HDFC Equity Fund",
      amount: "₹50,000",
      status: "Pending",
      createdAt: "2024-01-15",
      expiresAt: "2024-01-22",
      shareLink: "https://example.com/draft/abc123",
    },
    {
      id: 2,
      clientName: "Amit Patel",
      orderType: "SIP",
      schemeName: "SBI Bluechip Fund",
      amount: "₹10,000/month",
      status: "Pending",
      createdAt: "2024-01-14",
      expiresAt: "2024-01-21",
      shareLink: "https://example.com/draft/def456",
    },
    {
      id: 3,
      clientName: "Priya Sharma",
      orderType: "Lumpsum",
      schemeName: "ICICI Prudential Debt Fund",
      amount: "₹25,000",
      status: "Authorized",
      createdAt: "2024-01-10",
      expiresAt: "2024-01-17",
      shareLink: "https://example.com/draft/ghi789",
    },
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDraftForm(prev => ({ ...prev, [name]: value }));
  };

  const handleCreateDraft = (e) => {
    e.preventDefault();
    Swal.fire({
      icon: "success",
      title: "Draft Created!",
      text: "Draft order has been created successfully. Share the link with your client for authorization.",
      customClass: {
        popup: "custom-swal-popup",
      },
    });
    setShowCreateForm(false);
    setDraftForm({
      orderType: "Lumpsum",
      schemeName: "",
      amount: "",
      sipFrequency: "Monthly",
      sipStartDate: "",
      sipDuration: "",
    });
  };

  const handleShareLink = (link) => {
    navigator.clipboard.writeText(link);
    Swal.fire({
      icon: "success",
      title: "Link Copied!",
      text: "Draft link has been copied to clipboard.",
      timer: 1500,
      showConfirmButton: false,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };

  const handleCancelDraft = (draftId) => {
    Swal.fire({
      title: "Cancel Draft?",
      text: "Are you sure you want to cancel this draft order?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Cancel",
      cancelButtonText: "No",
      customClass: {
        popup: "custom-swal-popup",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: "Draft Cancelled",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    });
  };

  const isExpired = (expiresAt) => {
    return new Date(expiresAt) < new Date();
  };

  return (
    <>
    <AdvisorNavbar />
    <div className="page-content" style={{ background: "#f1f5f9" }}>

          {/* Header */}
          <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px" }}>
            {/* <div style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
              padding: "20px",
              borderRadius: "12px",
              borderBottom: "3px solid #39b2b4",
            }}> */}
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <div>
                  <h2 className="mb-1" >
                    Draft Orders
                  </h2>
                <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/agent/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">Draft Orders</li>
                </ol>
              </nav>
                </div>
                <button
                  className="btn btn-primary"
                  onClick={() => setShowCreateForm(!showCreateForm)}
                  style={{
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "10px 20px",
                    fontWeight: "500",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <FiPlus style={{ fontSize: "18px" }} />
                  Create Draft
                </button>
              {/* </div> */}
            </div>
          </div>

          {/* Create Draft Form */}
          {showCreateForm && (
            <div className="card shadow-sm mb-4" style={{ borderRadius: "12px", border: "none" }}>
              <div className="card-body p-4">
                <div style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                  padding: "16px",
                  borderRadius: "12px",
                  borderBottom: "3px solid #39b2b4",
                  marginBottom: "24px",
                }}>
                  <h4 className="mb-0" >
                    Create New Draft Order
                  </h4>
                </div>

                <form onSubmit={handleCreateDraft}>
                  <div className="row g-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                        Order Type <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <select
                        className="form-select"
                        name="orderType"
                        value={draftForm.orderType}
                        onChange={handleInputChange}
                        style={{
                          borderRadius: "8px",
                          border: "2px solid #e2e8f0",
                          fontSize: "14px",
                        }}
                        required
                      >
                        <option value="Lumpsum">Lumpsum</option>
                        <option value="SIP">SIP</option>
                      </select>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                        Scheme Name <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="schemeName"
                        value={draftForm.schemeName}
                        onChange={handleInputChange}
                        placeholder="Enter scheme name"
                        style={{
                          borderRadius: "8px",
                          border: "2px solid #e2e8f0",
                          fontSize: "14px",
                        }}
                        required
                      />
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                        Amount <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="amount"
                        value={draftForm.amount}
                        onChange={handleInputChange}
                        placeholder="Enter amount"
                        style={{
                          borderRadius: "8px",
                          border: "2px solid #e2e8f0",
                          fontSize: "14px",
                        }}
                        required
                      />
                    </div>

                    {draftForm.orderType === "SIP" && (
                      <>
                        <div className="col-12 col-md-6">
                          <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                            SIP Frequency
                          </label>
                          <select
                            className="form-select"
                            name="sipFrequency"
                            value={draftForm.sipFrequency}
                            onChange={handleInputChange}
                            style={{
                              borderRadius: "8px",
                              border: "2px solid #e2e8f0",
                              fontSize: "14px",
                            }}
                          >
                            <option value="Monthly">Monthly</option>
                            <option value="Quarterly">Quarterly</option>
                          </select>
                        </div>
                        <div className="col-12 col-md-6">
                          <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                            SIP Start Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="sipStartDate"
                            value={draftForm.sipStartDate}
                            onChange={handleInputChange}
                            style={{
                              borderRadius: "8px",
                              border: "2px solid #e2e8f0",
                              fontSize: "14px",
                            }}
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label className="form-label" style={{ color: "#1e293b", fontWeight: "500", fontSize: "14px" }}>
                            SIP Duration (months)
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="sipDuration"
                            value={draftForm.sipDuration}
                            onChange={handleInputChange}
                            placeholder="Enter duration"
                            style={{
                              borderRadius: "8px",
                              border: "2px solid #e2e8f0",
                              fontSize: "14px",
                            }}
                          />
                        </div>
                      </>
                    )}

                    <div className="col-12">
                      <div className="d-flex gap-2">
                        <button
                          type="submit"
                          className="btn"
                          style={{
                            background: "linear-gradient(135deg, #1bafb4 0%, #39b2b4 100%)",
                            color: "#ffffff",
                            border: "none",
                            borderRadius: "8px",
                            padding: "10px 24px",
                            fontWeight: "500",
                          }}
                        >
                          Create Draft
                        </button>
                        <button
                          type="button"
                          className="btn"
                          onClick={() => setShowCreateForm(false)}
                          style={{
                            background: "#f1f5f9",
                            color: "#64748b",
                            border: "none",
                            borderRadius: "8px",
                            padding: "10px 24px",
                            fontWeight: "500",
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Drafts List */}
          <div className="card shadow-sm" style={{ borderRadius: "12px", border: "none" }}>
            <div className="card-body p-4">
              <div style={{
                background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                padding: "16px",
                borderRadius: "12px",
                borderBottom: "3px solid #39b2b4",
                marginBottom: "24px",
              }}>
                <h4 className="mb-0" >
                  Draft Orders List
                </h4>
              </div>

              <div className="row g-3">
                {drafts.map((draft) => (
                  <div key={draft.id} className="col-12 col-md-6">
                    <div className="card" style={{
                      borderRadius: "12px",
                      border: isExpired(draft.expiresAt) ? "2px solid #ef4444" : "1px solid #e2e8f0",
                      background: isExpired(draft.expiresAt) ? "#fef2f2" : "#ffffff",
                    }}>
                      <div className="card-body p-4">
                        <div className="d-flex justify-content-between align-items-start mb-3">
                          <div>
                            <h6 className="mb-1" style={{ color: "#1e293b", fontSize: "16px", fontWeight: "600" }}>
                              {draft.clientName}
                            </h6>
                            <p className="mb-0" style={{ color: "#64748b", fontSize: "13px" }}>
                              {draft.schemeName}
                            </p>
                          </div>
                          <span className="badge" style={{
                            background: draft.status === "Authorized" ? "#d1fae5" : "#fef3c7",
                            color: draft.status === "Authorized" ? "#10b981" : "#f59e0b",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}>
                            {draft.status}
                          </span>
                        </div>

                        <div className="mb-3">
                          <p className="mb-1" style={{ color: "#64748b", fontSize: "13px" }}>
                            <strong>Type:</strong> {draft.orderType}
                          </p>
                          <p className="mb-1" style={{ color: "#64748b", fontSize: "13px" }}>
                            <strong>Amount:</strong> {draft.amount}
                          </p>
                          <div className="d-flex align-items-center mt-2">
                            <FiClock style={{ fontSize: "14px", color: "#64748b", marginRight: "4px" }} />
                            <span style={{ color: "#64748b", fontSize: "12px" }}>
                              Expires: {new Date(draft.expiresAt).toLocaleDateString()}
                            </span>
                            {isExpired(draft.expiresAt) && (
                              <span className="badge ms-2" style={{
                                background: "#fee2e2",
                                color: "#ef4444",
                                padding: "2px 8px",
                                borderRadius: "4px",
                                fontSize: "11px",
                              }}>
                                Expired
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="d-flex gap-2 flex-wrap">
                          <button
                            className="btn btn-sm"
                            onClick={() => handleShareLink(draft.shareLink)}
                            style={{
                              background: "linear-gradient(135deg, #ccf1f7 0%, #b3eaf4 100%)",
                              color: "#1bafb4",
                              border: "none",
                              borderRadius: "6px",
                              padding: "6px 12px",
                              fontSize: "12px",
                              fontWeight: "500",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <FiShare2 style={{ fontSize: "14px" }} />
                            Share Link
                          </button>
                          {draft.status === "Pending" && (
                            <button
                              className="btn btn-sm"
                              onClick={() => handleCancelDraft(draft.id)}
                              style={{
                                background: "#fee2e2",
                                color: "#ef4444",
                                border: "none",
                                borderRadius: "6px",
                                padding: "6px 12px",
                                fontSize: "12px",
                                fontWeight: "500",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <FiX style={{ fontSize: "14px" }} />
                              Cancel
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
      
    </div>
    </>
  );
}
